import { Guid } from "../../../utilities/guid";
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";

@autoinject
@transient()
export class CheckBox {

    public label: any;

    @bindable
    public identifier: string = Guid.generateGuid();

    @bindable
    public value: string;

    @bindable
    public theme: string = "primary";

    @bindable
    public checked: boolean;

    @bindable
    public disabled: boolean;

    @bindable
    public disableInput: boolean;

    @bindable
    public readonly: boolean;

    @bindable
    public tab: number;

    @bindable
    public htmlValue: boolean;

    constructor(private element: Element) { }

    attached(): void {

        // disables TabIndex when Disabled or Readonly

        if (this.disableInput || this.disabled || this.readonly) {

            this.tab = -1;
        }

        if (this.label) {
            this.label.addEventListener("keydown", this.onKeyDown, false);
        }
    }

    detached(): void {
        if (this.label) {
            this.label.removeEventListener("keydown", this.onKeyDown, false);
        }
    }

    private onKeyDown = (event: KeyboardEvent): void => {
        const code = event.keyCode;
        if (code === 32) {
            this.onClick(event);
            event.preventDefault();
        }
    }

    onClick($event: Event): void {
        if ($event) {
            $event.stopPropagation();
        }
        setTimeout(() => {
            this.check();
        });
    }

    disabledChanged(): void {
        if (this.disabled) {
            this.tab = -1;
        } else {
            this.tab = 0;
        }
    }

    public check(): void {

        if (this.readonly || this.disabled || this.disableInput) { return; }

        this.checked = !this.checked;
        setTimeout(() => {
            const changeEvent = new CustomEvent("changed", {
                detail: {
                    value: this.checked
                },
                bubbles: true
            });
            this.element.dispatchEvent(changeEvent);
        });
    }
}